const LEVEL_TEMPLATE = `
	<div>
		<h4><%= app.localeManager.get("filters.level")%>: <%= app.localeManager.get("levels." + reading_level.toLowerCase()) %></h4>
		<% if(reading_level == "Beginner") { %>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
		<% } %>
		<% if(reading_level == "Easy") { %>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
		<% } %>
		<% if(reading_level == "Average") { %>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
		<% } %>
		<% if(reading_level == "Advanced") { %>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle-o fa-2x"></i>
		<% } %>
		<% if(reading_level == "Expert") { %>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
			<i class="fa fa-circle fa-2x"></i>
		<% } %>
	</div>
`;

const Level = Backbone.View.extend({

	template: _.template(LEVEL_TEMPLATE),
	
	events: {
		"mouseover div"	: "showLevel",
		"mouseout div"	: "hideLevel",
	},

	showLevel: function() {
		this.$el.find("h4").css({ opacity: 1, top: "-35px" });
	},

	hideLevel: function() {
		this.$el.find("h4").css({ opacity: 0, top: "0px" });
	},

	render: function() {
		this.$el.html(this.template(this.model));

		return this;
	}

});